module.exports = {"create":"aanmaken","update":"aanpassen"}